import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ContactUsComponent } from './contact-us/contact-us.component';
import { InstallationComponent } from './installation/installation.component';
import { WhoAreWeComponent } from './who-are-we/who-are-we.component';
import { HowDoesItWorkComponent } from './how-does-it-work/how-does-it-work.component';
import { IntroComponent } from './intro/intro.component';
import { HeaderComponent } from './header/header.component';

@NgModule({
  declarations: [
    AppComponent,
    ContactUsComponent,
    InstallationComponent,
    WhoAreWeComponent,
    HowDoesItWorkComponent,
    IntroComponent,
    HeaderComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
